import React from 'react';
import style from './ArticlesContent.module.css';
import ArticlesItem from "./ArticlesItem";
import Paginator from "../common/Paginator/Paginator";
import LoadingArea from "../common/LoadingArea/LoadingArea";


const ArticlesContent = ({currentPage, totalArticlesCount, pageSize, onPageChanged, loading, ...props}) => {
    const paginator = (
        <Paginator currentPage={currentPage} onPageChanged={onPageChanged}
                   totalItemsCount={totalArticlesCount} pageSize={pageSize}/>
    );

    return (
        <div>
            <div className={style.title}>
                Всего статей: {totalArticlesCount}
            </div>
            {paginator}
            <LoadingArea loading={loading} className={style.articles}>
                {props.articles.length
                    ? props.articles.map(u => <ArticlesItem article={u} key={u.id}/>)
                    : null}
            </LoadingArea>
            {paginator}
        </div>
    )
}
export default ArticlesContent;
